import { type FC } from "react";
import Modal, { type Props as ModalProps } from "./Modal";

const MessageModal: FC<ModalProps> = ({
  agree = "Okay",
  cancel = "Cancel",
  size = "medium",
  canBeClosed = true,
  children,
  ...rest
}) => {
  return (
    <Modal
      cancel={cancel}
      size={size}
      agree={agree}
      canBeClosed={canBeClosed}
      formContainer={false}
      {...rest}
    >
      {children}
    </Modal>
  );
};

export default MessageModal;
